// removed by extract-text-webpack-plugin
module.exports = {"foreignCountryRow":"OLWnxWC7xiKDiuhLQP3Jv","propertyDescription":"_3jGfJDf-B6E6RuT8FF7Y3H","iconsWrapper":"_1wp_TKZv2Tqg-jMdZobwGA","labelNew":"_2DyYRMM4AHE0ur5ucTo6To","labelTop":"waW_5V8GNwBGpwGTz0MOH","propertyType":"aE3L-jchPYdDWU7yd4r10","propertyAddress":"_2WLc_rhAkrizY8bCLWLHLR","photoBlockWrapper":"_25OZo6sRzjLtBVnMm4Siwu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseForeignCountryCell/OMBaseForeignCountryCell.scss
// module id = 1675
// module chunks = 0